import { render, staticRenderFns } from "./dialog-form-wrapper.vue?vue&type=template&id=32561de1"
import script from "./dialog-form-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32561de1')) {
      api.createRecord('32561de1', component.options)
    } else {
      api.reload('32561de1', component.options)
    }
    module.hot.accept("./dialog-form-wrapper.vue?vue&type=template&id=32561de1", function () {
      api.rerender('32561de1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/forwarding-address/dialog-form-wrapper.vue"
export default component.exports